import {FormSelect} from '@vidazoo/ui-kit';
import useUserManager from '../../../../common/hooks/useUserManager';
import {observer} from 'mobx-react';
import {ReportingDbType, DbTypes} from '../../common/enums/ReportingDbType'
import {IBiReportingParams} from "../../common/interfaces/IReportingParams";

export interface IReportingDBsProps {
    dbType?: ReportingDbType;
    setParam: (key: keyof IBiReportingParams, value: any) => void;

}

function ReportingDBs(props: IReportingDBsProps) {
    const {
        dbType,
        setParam
    } = props;

    const onChangeDbTypes = (e) => {
        const value = e.target.value;
        setParam("dbType", value);
    };


    return (
        <FormSelect
            items={DbTypes}
            onChange={onChangeDbTypes}
            fill small
            label="DB Type"
            searchable
            name="dbType"
            placeholder="No Preference"
            value={dbType}/>
    )
}

export default observer(ReportingDBs);
